import { LogoSpinner } from './LogoSpinner';

interface LoadingStateProps {
  label?: string;
}

/** Full-area loading state with spinning logo — mirrors display's LoadingScreen. */
export function LoadingState({ label }: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16">
      <LogoSpinner size="lg" />
      {label && <p className="text-sm text-mute">{label}</p>}
    </div>
  );
}
